interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large'
  className?: string
  style?: React.CSSProperties
}

export default function LoadingSpinner({ size = 'medium', className = '', style = {} }: LoadingSpinnerProps) {
  const sizeClasses = {
    small: 'w-4 h-4',
    medium: 'w-8 h-8',
    large: 'w-12 h-12'
  }

  return (
    <div className={`loading ${className}`} data-testid="loading-spinner" style={style}>
      <div 
        className={`animate-spin rounded-full border-2 border-gray-300 border-t-blue-600 ${sizeClasses[size]}`}
        style={{
          borderColor: 'var(--border-color)',
          borderTopColor: 'var(--primary-blue)'
        }}
      />
    </div>
  )
}